module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"thumbnails_title":"이 상품의 다른 리뷰"}}')
  delete Component.options._Ctor
}
